import axios from 'axios';
import { useDialog } from 'muibox';
import { useContext, useState } from 'react';
import { SettingsContext } from '../store/SettingsContext';
import { UserContext } from '../store/UserContext';
import { handleHttpError } from '../utils/common';

const useCognitoGlobalSignOut = () => {
    const userContext = useContext(UserContext);
    const settingsContext = useContext(SettingsContext);
    const dialog = useDialog();
    const [globalSignOutLoading, setGlobalSignOutLoading] = useState<boolean>(false);

    const globalSignOut = async (subscriberId: string): Promise<boolean> => {
        if (!userContext.jwtToken || !settingsContext.apiKey || !userContext.user.username) {
            return false;
        }

        const query = `${settingsContext.routes.subscribers.base}${subscriberId}/cognito-global-sign-out`;

        setGlobalSignOutLoading(true);

        return axios
            .post<{ success: boolean }>(query, undefined, {
                headers: {
                    Authorization: userContext.jwtToken,
                    apiKey: settingsContext.apiKey,
                },
            })
            .then(response => {
                setGlobalSignOutLoading(false);

                return response.data.success === true;
            })
            .catch(error => {
                console.error('globalSignOut', error);
                setGlobalSignOutLoading(false);
                handleHttpError(error, dialog);

                return false;
            });
    };

    return { globalSignOut, globalSignOutLoading };
};

export default useCognitoGlobalSignOut;
